import { render } from "./Senarai.vue?vue&type=template&id=5acbca0b"
import script from "./Senarai.vue?vue&type=script&lang=js"
export * from "./Senarai.vue?vue&type=script&lang=js"

import "./Senarai.vue?vue&type=style&index=0&id=5acbca0b&lang=css"
import "./Senarai.vue?vue&type=style&index=1&id=5acbca0b&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__